export default __webpack_public_path__ + "static/media/fw-angela-er-Yellow Gold.a24b1e21.mp4";